var map = {
	"./IconTemplates_-01.svg": 2748,
	"./IconTemplates_-02.svg": 2749,
	"./IconTemplates_-03.svg": 2750,
	"./IconTemplates_-04.svg": 2751,
	"./IconTemplates_-05.svg": 2752,
	"./IconTemplates_-06.svg": 2753,
	"./IconTemplates_-07.svg": 2754,
	"./IconTemplates_-08.svg": 2755,
	"./IconTemplates_-09.svg": 2756,
	"./IconTemplates_-10.svg": 2757,
	"./IconTemplates_-100.svg": 2758,
	"./IconTemplates_-11.svg": 2759,
	"./IconTemplates_-12.svg": 2760,
	"./IconTemplates_-13.svg": 2761,
	"./IconTemplates_-14.svg": 2762,
	"./IconTemplates_-15.svg": 2763,
	"./IconTemplates_-16.svg": 2764,
	"./IconTemplates_-17.svg": 2765,
	"./IconTemplates_-18.svg": 2766,
	"./IconTemplates_-19.svg": 2767,
	"./IconTemplates_-20.svg": 2768,
	"./IconTemplates_-21.svg": 2769,
	"./IconTemplates_-22.svg": 2770,
	"./IconTemplates_-23.svg": 2771,
	"./IconTemplates_-24.svg": 2772,
	"./IconTemplates_-25.svg": 2773,
	"./IconTemplates_-26.svg": 2774,
	"./IconTemplates_-27.svg": 2775,
	"./IconTemplates_-28.svg": 2776,
	"./IconTemplates_-29.svg": 2777,
	"./IconTemplates_-30.svg": 2778,
	"./IconTemplates_-31.svg": 2779,
	"./IconTemplates_-32.svg": 2780,
	"./IconTemplates_-33.svg": 2781,
	"./IconTemplates_-34.svg": 2782,
	"./IconTemplates_-35.svg": 2783,
	"./IconTemplates_-36.svg": 2784,
	"./IconTemplates_-37.svg": 2785,
	"./IconTemplates_-38.svg": 2786,
	"./IconTemplates_-39.svg": 2787,
	"./IconTemplates_-40.svg": 2788,
	"./IconTemplates_-41.svg": 2789,
	"./IconTemplates_-42.svg": 2790,
	"./IconTemplates_-43.svg": 2791,
	"./IconTemplates_-44.svg": 2792,
	"./IconTemplates_-45.svg": 2793,
	"./IconTemplates_-46.svg": 2794,
	"./IconTemplates_-47.svg": 2795,
	"./IconTemplates_-48.svg": 2796,
	"./IconTemplates_-49.svg": 2797,
	"./IconTemplates_-50.svg": 2798,
	"./IconTemplates_-51.svg": 2799,
	"./IconTemplates_-52.svg": 2800,
	"./IconTemplates_-53.svg": 2801,
	"./IconTemplates_-54.svg": 2802,
	"./IconTemplates_-55.svg": 2803,
	"./IconTemplates_-56.svg": 2804,
	"./IconTemplates_-57.svg": 2805,
	"./IconTemplates_-58.svg": 2806,
	"./IconTemplates_-59.svg": 2807,
	"./IconTemplates_-60.svg": 2808,
	"./IconTemplates_-61.svg": 2809,
	"./IconTemplates_-62.svg": 2810,
	"./IconTemplates_-63.svg": 2811,
	"./IconTemplates_-64.svg": 2812,
	"./IconTemplates_-65.svg": 2813,
	"./IconTemplates_-66.svg": 2814,
	"./IconTemplates_-67.svg": 2815,
	"./IconTemplates_-68.svg": 2816,
	"./IconTemplates_-69.svg": 2817,
	"./IconTemplates_-70.svg": 2818,
	"./IconTemplates_-71.svg": 2819,
	"./IconTemplates_-72.svg": 2820,
	"./IconTemplates_-73.svg": 2821,
	"./IconTemplates_-74.svg": 2822,
	"./IconTemplates_-75.svg": 2823,
	"./IconTemplates_-76.svg": 2824,
	"./IconTemplates_-77.svg": 2825,
	"./IconTemplates_-78.svg": 2826,
	"./IconTemplates_-79.svg": 2827,
	"./IconTemplates_-80.svg": 2828,
	"./IconTemplates_-81.svg": 2829,
	"./IconTemplates_-82.svg": 2830,
	"./IconTemplates_-83.svg": 2831,
	"./IconTemplates_-84.svg": 2832,
	"./IconTemplates_-85.svg": 2833,
	"./IconTemplates_-86.svg": 2834,
	"./IconTemplates_-87.svg": 2835,
	"./IconTemplates_-88.svg": 2836,
	"./IconTemplates_-89.svg": 2837,
	"./IconTemplates_-90.svg": 2838,
	"./IconTemplates_-91.svg": 2839,
	"./IconTemplates_-92.svg": 2840,
	"./IconTemplates_-93.svg": 2841,
	"./IconTemplates_-94.svg": 2842,
	"./IconTemplates_-95.svg": 2843,
	"./IconTemplates_-96.svg": 2844,
	"./IconTemplates_-97.svg": 2845,
	"./IconTemplates_-98.svg": 2846,
	"./IconTemplates_-99.svg": 2847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 639;